import { post, get } from "../http.js";

export function fetchCode(data) {
  return post({
    url: "/company/sendSms",
    data: {
      ...data,
    },
  });
}

export function postRegster(data) {
  return post({
    url: "/company/reg",
    data: {
      ...data,
    },
  });
}

export function postInviteCode(data) {
  return post({
    url: "/company/add",
    data: {
      ...data,
    },
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    baseURL: "http://www.dividiy.com/system/log",
  });
}
